
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { AppConstants } from '../constants/AppConstants';
import StoreInfo from './shared/StoreInfo.jsx';
import AppActions from '../../js/app/app_actions';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Footer.jsx] ";
        this.enterDebug = this.enterDebug.bind(this);
        this.testOnClick = this.testOnClick.bind(this);
    }

    enterDebug() {
        this.props.getDebug();
    }

    testOnClick() {
        this.props.history.push({ pathname: '/test', state: { showCollapse: true } });
    }

    render() {
        console.log(this.componentName + 'render');

        let info = this.props.versionInformation;
        let deb = this.props.debugObj;
        let year = new Date().getFullYear();

        let red = { color: 'red' };
        let blue = { color: 'blue' };
        let green = { color: 'green' };
        let yellow = { color: 'yellow' };
        let white = { color: 'white', marginTop: '1em' }

        return (
            <nav className="d-none navbar navbar-dark bg-dark mt-3">
                <div className="d-block d-sm-none" style={red}>XS - Extra Small devices Tablets (0,576px) </div>
                <div className="d-none d-sm-block d-md-none" style={blue}>SM - Small devices Tablets (576px,768px) </div>
                <div className="d-none d-md-block d-lg-none" style={white}>MD - Medium devices Desktops (768px,992px) </div>
                <div className="d-none d-lg-block d-xl-none" style={green}>LG - Large devices Desktops (992px,1200px) </div>
                <div className="d-none d-xl-block" style={yellow}>XL - Extra Large devices Desktops `{'(>'}`= 1200px) </div>

                {AppConstants.DEBUG_VIEW ? <button type="button" className="btn btn-primary pull-right" onClick={this.testOnClick} >Test</button> : null}

                {AppConstants.SHOW_STORE_INFO ? <StoreInfo /> : null}
                <p>
                    <a className="lsmall" href="#/whatsnew" >{AppConstants.APP_NAME} ver. {AppConstants.VERSIONE} </a>

                    {this.props.versionInformation !== null ?
                        this.props.versionInformation.idServer + "-" + this.props.versionInformation.version + "-" +
                        this.props.versionInformation.subVersion + "-" + this.props.versionInformation.release + "-" + this.props.versionInformation.releaseDate + "   "
                        : null}
                </p>
            </nav >
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getVersionInfo: function () {
            return dispatch(AppActions.getVersionInfo());
        },
        getDebug: function () {
            return dispatch(AppActions.getDebug());
        },
    };
};

function mapStateToProps(state) {
    return {
        versionInformation: state.app.versionInformation,
        debugObj: state.app.debugObj,

    };

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));